import Service from "@/utils/api/service";
import Pagination from "@/components/share/pagination";
import Helper from "@/utils/global/func";
import TableLoading from "@/components/share/table-loading";
import NoItem from "@/components/share/table-no-item";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { mapState } from "vuex";
import _debounce from "lodash.debounce";
import Multiselect from "vue-multiselect";

export default {
  name: "ListBranch",
  data() {
    return {
      isFetching: true,
      isDeleting: false,
      isNoData: false,
      fields: {
        id: "",
        index: "",
      },
      search: {
        warehouseId: "",
        warehouseName: "",
      },
      display: {
        modal: {
          delete: {
            index: -1,
            show: false,
          },
          imagePreview: {
            show: false,
            index: "",
          },
        },
      },
      data: {
        limit: 10,
        detail: {},
        items: [],
        pagination: {
          limit: 10,
          page: 1,
          total: 0,
          totalPage: 0,
        },
      },

      // filter warehouse
      warehouses: this.$master?.warehouses || [],
      allWarehouses: this.$master?.warehouses || [],
      debouncedOnSearchWarehouses: null,
    };
  },
  components: {
    Pagination,
    TableLoading,
    NoItem,
    DatePicker,
    Multiselect,
  },
  created() {
    this.setParams();
    this.getBranchs();

    this.debouncedOnSearchWarehouses = _debounce(
      this.handleWarehouseSearchChange,
      500
    );
  },
  watch: {
    "$route.fullPath": function () {
      this.setParams();
      this.getBranchs();
    },
  },
  computed: {
    ...mapState(["permissions"]),
  },
  mounted() {},
  methods: {
    setParams() {
      this.search = this.$helper.setParams(
        this.search,
        this.$root.$route.query
      );
    },

    checkoutPermission(permissionName) {
      if (this.permissions) {
        let result = false;
        this.permissions.find((item) => {
          item.permissions.find((permission) => {
            if (permission.name == permissionName) {
              result = true;
            }
          });
        });

        return result;
      }
    },

    getFullImage(path) {
      return process.env.VUE_APP_BASE_URL_IMAGE + path;
    },

    htmlToText(html) {
      return Helper.convertToPlain(html);
    },

    linkPage(type, index) {
      if (index >= 0) {
        this.$router.push({
          name: type,
          query: { id: this.data.items[index].id },
        });
      } else
        this.$router.push({
          name: type,
        });
    },

    handleWarehouseSearchChange(query) {
      if (!query || query.trim() === "") {
        this.warehouses = [...this.allWarehouses];
        return;
      }

      this.filterWarehouse(this.allWarehouses, query);
    },

    filterWarehouse(data, search) {
      if (!search || search.trim() === "") {
        this.warehouses = data;
        return;
      }

      const normalizedSearch = search.toLowerCase().trim();

      const items = data.filter((item) => {
        const matchName = item.name?.toLowerCase().includes(normalizedSearch);
        const matchCode = item.code?.toLowerCase().includes(normalizedSearch);

        return matchName || matchCode;
      });

      this.warehouses = items;
    },

    onWarehouseSelected() {
      this.getBranchs();
    },

    getBranchs() {
      this.isFetching = true;
      this.isNoData = false;
      let query = this.$root.$route.query;
      let setQuery = this.$helper.filterKeyMapping({
        page: query?.page || 1,
        warehouseId: this.search.warehouseName?.id || "",
        ...query,
      });

      let params = this.$helper.queryParam(setQuery);

      Service.getBranchs(params).then((response) => {
        this.isFetching = false;
        if (response?.statusCode) {
          if (response?.statusCode === "4410") {
            Service.refreshToken().then((response) => {
              if (response === "ok") {
                this.getBranchs();
              }
            });
          } else if (response?.statusCode === "403") {
            this.isNoData = true;
            this.data.items = [];
            this.$toasted.show(response?.message);
            return;
          } else {
            this.$toasted.show(response?.message);
            return;
          }
        } else {
          if (response?.data.length > 0) {
            this.isNoData = false;
            this.data.items = response?.data;
            this.data.pagination = Helper.calculatePagination(response?.meta);
            return;
          } else {
            this.data.items = [];
            this.isNoData = true;
            return;
          }
        }
      });
    },

    async searchItems() {
      let query = this.$helper.filterKeyMapping({
        limit: 10,
        page: 1,
        ...this.search,
      });
      await this.$router.push({ query }).catch(() => {});
    },

    popupModalDelete(index) {
      this.display.modal.delete.index = index;
      this.display.modal.delete.show = true;
    },

    deleteBranch() {
      this.isDeleting = true;
      let branchId = this.data.items[this.display.modal.delete.index].id;

      Service.deleteBranch(branchId).then((response) => {
        if (response.statusCode) {
          if (response.statusCode == "4410") {
            Service.refreshToken().then((response) => {
              if (response == "ok") {
                this.deleteBranch();
              }
            });
          } else {
            this.isDeleting = false;
            this.$toasted.show(response.message);
          }
        } else {
          this.isDeleting = false;
          this.data.items.splice(this.display.modal.delete.index, 1);
          this.data.pagination.total -= 1;
          this.$toasted.show("Branch has been deleted.");
          this.closeModal();
        }
      });
    },

    imagePreview(index) {
      if (this.data.items[index].imageUrl) {
        this.display.modal.imagePreview.index = index;
        this.display.modal.imagePreview.show = true;
      }
    },

    closeModal() {
      this.display = {
        modal: {
          delete: {
            index: -1,
            show: false,
          },
          imagePreview: {
            show: false,
            index: "",
          },
        },
      };
    },
  },
};
